module.exports = __webpack_public_path__ + "static/media/logo-stadium-w.e2041a59.png";